import { render, staticRenderFns } from "./ReplacementPatrimony.vue?vue&type=template&id=4df7e93a&scoped=true&"
import script from "./ReplacementPatrimony.vue?vue&type=script&lang=js&"
export * from "./ReplacementPatrimony.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementPatrimony.vue?vue&type=style&index=0&id=4df7e93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7e93a",
  null
  
)

export default component.exports